import { call, put, takeLatest } from 'redux-saga/effects'
import { push } from 'connected-react-router'
import { forgotPassword, setNewPassword } from './forgotPassword.reducer'

import Api from '../../services/ApiCaller'
import { showMessage } from '../../utils'
import { translate } from '../../i18n'


export function* forgotPasswordRequest(api: any, { payload }: any) {
  try {
    const { res = {} } = yield call(Api.callServer, api, payload, true)
    const { error, message } = res
    if (!error) {
      yield put(forgotPassword.success(res))
      showMessage(`${translate('loginMessages.SuccesfulLinkSend')}`)
    } else {
      yield put(forgotPassword.failure(message))
    }
  } catch (e) {
    yield put(forgotPassword.failure(e.message))
  }
}

export function* setNewPasswordRequest(api: any, { payload }: any) {
  try {
    const { res = {} } = yield call(Api.callServer, api, payload, true)
    const { error, message } = res
    if (!error) {
      yield put(setNewPassword.success(res))
      showMessage(`${translate('loginMessages.SuccessfulPasswordSet')}`)
      yield put(push('/login'))
    } else {
      yield put(setNewPassword.failure(message))
    }
  } catch (e) {
    yield put(setNewPassword.failure(e.message))
  }
}
export default (api: any) => {
  const forgotPasswordApi = (data: any) =>
    api.post(`/users/forgot-password`, data)

  const setNewPasswordApi = (data: any) =>
    api.post(`/users/forgot-password/set/?token=${data.token}`, data)

  return [
    takeLatest(
      forgotPassword.TRIGGER,
      forgotPasswordRequest,
      forgotPasswordApi
    ),
    takeLatest(setNewPassword.TRIGGER, setNewPasswordRequest, setNewPasswordApi)
  ]
}
